import useObjectUrl from 'hooks/useObjectUrl';
import useSlide from '../useSlide';

export default function useSlideSrc(id: string) {
  const slide = useSlide(id);
  return useObjectUrl(slide?.imageSrc);
}
